export const DOCUMENT_TAB_CATEGORIES = [
    "manual",
    "boms",
    "mechanical-drawings",
    "controls-drawings",
    "certification",
    "food-compliance",
    "others",
];

export const KNOWN_DOCUMENT_CATEGORIES = [
    "manual",
    "boms",
    "mechanical-drawings",
    "controls-drawings",
    "certification",
    "food-compliance",
];

export const normalizeDocumentCategoryKey = (value = "") => {
    const normalized = String(value || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

    const aliases = {
        control: "controls-drawings",
        controls: "controls-drawings",
        "control-drawings": "controls-drawings",
        compliance: "certification",
        certificate: "certification",
        certificates: "certification",
        certifications: "certification",
        translation: "manual",
        translations: "manual",
        translated: "manual",
        "food-conformity": "food-compliance",
        uncategorized: "others",
        rspl: "others",
    };

    return aliases[normalized] || normalized;
};

export const getDocumentCategoryLabel = (t, categoryKey) => {
    const labels = {
        manual: t("LABELS.MANUALS"),
        boms: t("LABELS.BOMS"),
        "mechanical-drawings": t("LABELS.MECHANICAL_DRAWINGS"),
        "controls-drawings": t("LABELS.CONTROLS_DRAWINGS"),
        certification: t("LABELS.CERTIFICATION"),
        "food-compliance": t("LABELS.FOOD_COMPLIANCE"),
        others: t("LABELS.OTHERS"),
    };

    return labels[categoryKey] || categoryKey;
};
